<script setup lang="ts">
import { computed, inject } from "vue";
import _ from "lodash";

const displayConfig = inject("displayConfig");
const product = inject("product");

const props = defineProps({
    retailersProp: String,
});

const retailers = computed(() => {
    const retailers = _.get(product.value, props.retailersProp);
    const retailersFiltered = [];
    if (retailers) {
        retailers.forEach((retailer) => {
            if (!retailer.as_add_to_cart) {
                retailersFiltered.push(retailer);
            }
        });
    }
    return retailersFiltered;
});

const retailerAddToCart = computed(() => {
    const retailers = _.get(product.value, props.retailersProp);
    let retailer = null;
    if (retailers) {
        retailers.forEach((_retailer) => {
            if (_retailer.as_add_to_cart) {
                retailer = _retailer;
            }
        });
    }
    return retailer;
});

function retailerNameClean(name) {
    return name.replace(/\s?physique|numérique/gim, "");
}

const isReallyCropped = computed(() => {
    return (
        !displayConfig.value.display_all_retailers &&
        ((displayConfig.value.layout === "side" &&
                retailers?.value.length > 12) ||
            (displayConfig.value.layout === "popup" &&
                retailers?.value.length > 10))
    );
});
</script>

<template>
    <div>
        <h3>{{ $t("Commander en ligne") }}</h3>
        <div v-if="retailerAddToCart" class="add-to-cart">
            <a
                :href="
                    retailerAddToCart.retailer_api_url ||
                    retailerAddToCart.affiliate_url ||
                    retailerAddToCart.standard_url
                "
                target="_blank"
                :class="{
                    'rounded-large':
                        displayConfig.retailers_style_labels_border_radius ===
                        'rounded-large',
                    'rounded-small':
                        displayConfig.retailers_style_labels_border_radius ===
                        'rounded-small',
                }"
            >{{ $t("Ajouter au panier") }}</a
            >
            <div v-if="retailers.length > 0">
                <span>{{ $t("ou commander avec nos partenaires") }}</span>
            </div>
        </div>
        <div
            class="grid"
            :class="{
                'grid--cropped': isReallyCropped,
                'grid--logos': displayConfig.retailers_style === 'logos',
                'grid--labels': displayConfig.retailers_style === 'labels',
                'grid--logos--4cols': displayConfig.retailers_grid_layout === 4,
                'grid--logos--3cols': displayConfig.retailers_grid_layout === 3,
            }"
        >
            <div v-for="retailer in retailers">
                <a
                    :href="
                        retailer.pivot.custom_link ||
                        retailer.retailer_api_url ||
                        retailer.affiliate_url ||
                        retailer.standard_url
                    "
                    target="_blank"
                    :title="retailerNameClean(retailer.name)"
                    :class="{
                        'rounded-large':
                            displayConfig.retailers_style_labels_border_radius ===
                            'rounded-large',
                        'rounded-small':
                            displayConfig.retailers_style_labels_border_radius ===
                            'rounded-small',
                    }"
                    :aria-label="retailerNameClean(retailer.name) + ', nouvel onglet'"
                    tabindex="20"
                >
                    <img
                        :src="retailer.logo_url"
                        :alt="retailer.name"
                        v-if="displayConfig.retailers_style === 'logos'"
                        role="presentation"
                    />
                    <span v-if="displayConfig.retailers_style === 'labels'">{{
                            retailerNameClean(retailer.name)
                        }}</span>
                </a>
            </div>
        </div>
        <button
            class="btn-all"
            v-if="isReallyCropped"
            @click="
                displayConfig.display_all_retailers =
                    !displayConfig.display_all_retailers
            "
        >
            {{ $t("Voir tout") }}
        </button>
    </div>
</template>
